import React from 'react';
import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import LoadingGif from '../../../../static/images/loading.gif';
import TOLogo from '../../../../static/images/TO/toyota-logo.svg';
import AppVars from '../../../../AppVars.js';

import returnTitle from './CodeTitles'
import returnHeader from "./CodeHeaders";
import returnError from './CodeErrors'
import { DigitInput } from '../Login/DigitInput';
import pushLinkAnalytics from '../../../../analytics/pushLinkAnalytics.js';
const appVars = AppVars.getInstance();

const COMPONENT_TREE = [{ component_name: 'VerifyAccount', component_version: '1.0.0' }];
class VerifyCodeView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
        };
    }

    render() {
        return (
            <>
                <div className="justify-content-center line-box">
                    <Col>
                        <div role="banner">
                            <Row className="">
                                <Link to={appVars.getAppHomeURL(this.props.style)}><Image className="corner-logo absolute" alt="Toyota" src={require('../../../../static/images/Toyota-Logo.svg').default} /></Link>
                            </Row>
                        </div>
                        {/* <div id="submitOTPLoginAlert"
                            data-testid="OTPLoginAlert"
                            className={`${this.props.isResponseValid === false ? "error-modal" : "none"}`}
                            role="alert"
                            aria-hidden={`${this.props.isResponseValid === false ? "false" : "true"}`}>
                            <div className="error-modal-text">
                                The service is down. Please try again shortly.
                            </div>
                            <span onClick={this.props.hideModal} className="modal-close absolute">&times;</span>
                        </div> */}
                        <div
                            id="logonAlert"
                            data-testid="accountLockedError"
                            className={`${this.props.isAccountLocked === true ? "error-modal" : "none"}`}
                            role="alert"
                            aria-hidden={`${this.props.isAccountLocked === true ? "false" : "true"}`}
                        >
                            <div className="error-modal-text">
                                This account is locked for 15 minutes due to multiple failed attempts. Please try again later or <Link to="https://www.toyota.com/support/contact-us"><u>contact us</u></Link> for help unlocking your account.
                            </div>
                            <span onClick={this.props.hideModalLocked} className="modal-close">&times;</span>
                        </div>
                        <div
                            id="logonAlert"
                            data-testid="temporaryLockedError"
                            className={`${this.props.isLoginValid === false ? "error-modal" : "none"}`}
                            role="alert"
                            aria-hidden={`${this.props.isLoginValid === false ? "false" : "true"}`}
                        >
                            <div className="error-modal-text">
                                Invalid OTP. An excessive number of failed attempts will temporarily lock your account.
                            </div>
                            <span onClick={this.props.hideModalInvalid} className="modal-close">&times;</span>
                        </div>
                        <div
                            id="logonAlert"
                            data-testid="otpResendError"
                            className={`${this.props.isResendOtpDisabled === true ? "error-modal" : "none"}`}
                            role="alert"
                            aria-hidden={`${this.props.isResendOtpDisabled === true ? "false" : "true"}`}
                        >
                            <div className="error-modal-text">
                                Too many OTPs sent. Please try again after some time.
                            </div>
                            <span onClick={this.props.hideModalResend} className="modal-close">&times;</span>
                        </div>
                        <div role="main">
                            {returnTitle(this.props.showForm, this.props.signInType)}
                            {returnHeader(this.props.showForm, this.props.signInType)}
                            <Row>
                                <div className="subTitle__TO left" >{this.props.displayUsername}</div>
                            </Row>
                            <Form id="submitOTPLogin__TO" noValidate validated={this.props.isOTPValid} onSubmit={this.props.submitOTP}>
                                <Form.Group className="relative" id="verifyCodeForm">
                                    {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                            in order to disable native popup error*/}
                                    <DigitInput value={this.props.OTPValue} valueLength={6} onChange={this.props.handleOTPChange} />
                                    <div
                                        id="OTPValueAlert"
                                        data-testid="OTPValueError"
                                        className={`logon-item-error__TO ${this.props.isOTPValid === false && this.props.onFocus === false ? "block" : "none"}`}
                                        role="alert"
                                        aria-hidden={`${this.props.isOTPValid === false && this.props.onFocus === false ? "false" : "true"}`}
                                    >
                                        Enter verification code.
                                    </div>
                                    <div
                                        id="OTPResendAlert"
                                        data-testid="OTPValueError"
                                        className={`logon-item-error__TO ${this.props.isCodeResent === true && this.props.onFocus === false ? "block" : "none"}`}
                                        role="alert"
                                        aria-hidden={`${this.props.isCodeResent === true && this.props.onFocus === false ? "false" : "true"}`}
                                        style={{ color: "#28a745" }}
                                    >
                                        OTP resent successfully !
                                    </div>
                                    <div
                                        id="OTPValueAlert"
                                        data-testid="OTPValueError"
                                        className={`logon-item-error__TO ${this.props.isCodeInvalid === true && this.props.onFocus === false ? "block" : "none"}`}
                                        role="alert"
                                        aria-hidden={`${this.props.isCodeInvalid === true && this.props.onFocus === false ? "false" : "true"}`}
                                    >
                                        {returnError(this.props.showForm, this.props.signInType)} Request a new code to try again.
                                    </div>
                                    <div
                                        id="OTPExpiredAlert"
                                        data-testid="OTPValueError"
                                        className={`logon-item-error__TO ${this.props.isCodeExpired === true ? "block" : "none"}`}
                                        role="alert"
                                        aria-hidden={`${this.props.isCodeExpired === true ? "false" : "true"}`}
                                    >
                                        Verification code has expired. Please try again.
                                    </div>
                                </Form.Group>
                                {(!this.props.isResendOtpDisabled && !this.props.isCodeExpired) && <div className="flex request-code">
                                    <Link tabIndex={0} onClick={this.props.getNewOTP} className="link__TO" style={{ 'textTransform': 'none', 'display': 'inline', 'cursor': 'pointer' }}>Request New Code</Link>
                                </div>}
                                <Button data-testid="OTPLoginButton" className={`${this.props.isOTPValid !== true ? "button-disabled__TO" : "button__TO"} `} type={this.props.isOTPValid && "submit"} style={{ marginTop: "50px" }}>{(this.props.showForm === "RESET" || this.props.showForm === "VERIFY") ? "Continue" : "Sign In"}</Button>
                                <Image data-testid="loadingGIF" className={`working ${this.props.loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
                            </Form>
                        </div>
                    </Col>
                </div>
                {this.props.signInType === "OTP" ?
                    <div className='otp-bottom-text'>
                        <div className="sign-in-otp">
                            <div className="code-bottom-title"> Still having trouble?</div><br />
                        </div>
                        <div className="code-bottom code-bottom-otp" role="complementary">
                            <Link tabIndex={0} style={{ "textAlign": "left" }} onClick={() => this.props.handlePasswordLogin()} className="bottom-link bottom-link-code">Sign In With Password<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></Link>
                            <Link className="bottom-link bottom-link-code" to="/" onClick={() => { pushLinkAnalytics({ ctaText: 'Try a Different Sign In', href: "/", content_section: 'Sign in Verify by Text', tree: COMPONENT_TREE }); }}>Try a Different Sign In<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></Link>
                            <Link className="bottom-link" to={appVars.getSupportURL()} onClick={() => { pushLinkAnalytics({ ctaText: 'Support', href: appVars.getSupportURL(), content_section: 'Sign in Verify by Text', tree: COMPONENT_TREE }); }}>Support<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></Link>
                        </div>
                    </div>
                    :
                    <div className="code-bottom email-bottom" role="complementary">
                        <div className="code-bottom-title"><span className="sign-in">Still having trouble?</span>
                            <br className="mobile-br" />
                            <div className='bottom-duration'>
                                <Link style={{ "marginRight": "17px" }} className="bottom-link" to="/" onClick={() => { pushLinkAnalytics({ ctaText: 'Try a Different Sign In', href: "/", content_section: 'Sign in Verify by Text', tree: COMPONENT_TREE }); }}>Try a Different Sign In<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></Link>
                                <Link className="bottom-link" to={appVars.getSupportURL()} onClick={() => { pushLinkAnalytics({ ctaText: 'Support', href: appVars.getSupportURL(), content_section: 'Sign in Verify by Text', tree: COMPONENT_TREE }); }}>Support<img src={require('../../../../static/images/arrow.png')} alt="arrow" className='arrow-right' width="15px" /></Link>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}

export default VerifyCodeView;